import React from 'react'
import Header from './components/Header'
import { Footer } from './components/Footer'
import { Contactform } from './components/Contactform'

export const Disclaimer = () => {
  return (
    <>
        <Header />
        <section id='banner' className='p-0'>
                    <div className='banner booknow filter m-0 h-120'>                     
                    </div>
            </section>
            <section id='contentpage'>
                <div className='contentpage'>
                        <div className='container'>
                                <div className='row'>
                                    <div className='web-container'>
                                        <div className='heading'>
                                                <h4>Disclaimer</h4>
                                        </div>
                                            <p>The information contained in this website is for general information purposes only. The information is provided by NETPLUS and while we endeavor to keep the information up to date and correct, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability or availability with respect to the website or the information, products, services, or related graphics contained on the website for any purpose. Any reliance you place on such information is therefore strictly at your own risk.In no event will we be liable for any loss or damage including without limitation, indirect or consequential loss or damage, or any loss or damage whatsoever arising from loss of data or profits arising out of, or in connection with, the use of this website. Through this website you are able to link to other websites which are not under the control of NETPLUS.. We have no control over the nature, content and availability of those sites. The inclusion of any links does not necessarily imply a recommendation or endorse the views expressed within them.</p>
                                            <p>Every effort is made to keep the website up and running smoothly. However, NETPLUS takes no responsibility for, and will not be liable for, the website being temporarily unavailable due to technical issues beyond our control.</p>
                                        </div>
                                    </div>
                        </div>
                </div>
            </section>
        {/* <Contactform /> */}
        <Footer />
    </>
  )
}
